import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomTimelineVersion } from '../../model/kamonal-model';

@Component({
    selector: 'app-kamona-password-widget',
    templateUrl: './kamona-password-widget.component.html',
    styleUrls: ['./kamona-password-widget.component.scss'],
})
export class KamonaPasswordWidgetComponent implements OnInit {
    readonly CustomTimelineVersion = CustomTimelineVersion;
    @Output() emitNext = new EventEmitter();
    @Output() emitSubmit = new EventEmitter();
    @Output() emitBack = new EventEmitter();
    @Input() oldPasswordHints = DefaultOldPasswordHints;
    @Input() newPasswordHints = DefaultNewPasswordHints;
    @Input() useOldPasswordHint = true;
    @Input() useNewPasswordHint = true;
    @Input() submitting: boolean;
    @Input() hideBackBtn: boolean;
    @Input() description: string;
    @Input() oldPasswordPlaceHolder = 'Enter Current Password';
    @Input() newPasswordPlaceHolder = 'Enter New Password';
    @Input() title: string;
    @Input() minHeight = 510;
    @Input() currentStep: number;
    @Input() totalStep: number;
    @Input() previousTitle: string;
    @Input() regexExp = DefaultPasswordRegex;
    @Input() usePasswordForm = true;
    @Input() btnText = 'Done';
    validForm: boolean;
    validOldPassword: boolean;
    validNewPassword: boolean;
    oldPassword: string;
    newPassword: string;
    isVisibleOldPwd: boolean;
    isVisibleNewPwd: boolean;
    constructor() {}

    ngOnInit(): void {}

    goBack() {
        this.emitBack.emit();
    }

    submit() {
        const oldPassword = this.oldPassword;
        const newPassword = this.newPassword;
        this.emitSubmit.emit({ oldPassword, newPassword });
    }

    handleOldPassword($event: string) {
        this.oldPassword = $event;
        this.emitPassword();
        this.handleOldPasswordHints($event);
        this.isValidOldPassword();
    }

    handleOldPasswordHints(password: string) {
        const usePwdHint = !this.usePasswordForm || !this.useOldPasswordHint;
        if (usePwdHint) {
            return;
        }
        this.oldPasswordHints.forEach((hint) => {
            hint.isPassed = hint.regex.test(password);
        });
    }

    emitPassword() {
        if (this.usePasswordForm) {
            return;
        }
        this.emitSubmit.emit(this.oldPassword);
    }

    setVisibleOldPassword(visible: boolean) {
        this.isVisibleOldPwd = visible;
        this.setPasswordDocumentVisibility('oldPassword');
    }

    setVisibleNewPassword(visible: boolean) {
        this.isVisibleNewPwd = visible;
        this.setPasswordDocumentVisibility('newPassword');
    }

    setPasswordDocumentVisibility(elementById: string) {
        const pwdDocument: any = document.getElementById(elementById);
        if (pwdDocument?.type === 'password') {
            pwdDocument.type = 'text';
        } else {
            pwdDocument.type = 'password';
        }
    }

    isValidOldPassword() {
        if (!this.useOldPasswordHint) {
            this.validOldPassword = this.regexExp.test(this.oldPassword);
            return;
        }
        let noOfPass = 0;
        this.oldPasswordHints.forEach((hint) => {
            if (hint.isPassed) {
                noOfPass += 1;
            }
        });
        this.validOldPassword = this.oldPasswordHints.length === noOfPass;
    }

    isValidNewPassword() {
        if (!this.useNewPasswordHint) {
            this.validNewPassword = this.regexExp.test(this.oldPassword);
            return;
        }
        let noOfPass = 0;
        this.newPasswordHints.forEach((hint) => {
            if (hint.isPassed) {
                noOfPass += 1;
            }
        });
        this.validNewPassword = this.newPasswordHints.length === noOfPass;
    }

    handleNewPassword($event: string) {
        this.newPassword = $event;
        if (!this.useNewPasswordHint) {
            return;
        }
        this.newPasswordHints.forEach((hint) => {
            hint.isPassed = hint.regex.test($event);
        });
        this.isValidNewPassword();
    }
}

export const DefaultPasswordRegex = new RegExp('.{8,}');

export const DefaultOldPasswordHints: PasswordHints[] = [
    {
        isPassed: false,
        hint: 'A Lowercase letter (a)',
        regex: new RegExp('[a-z]'),
    },
    {
        isPassed: false,
        hint: 'An Uppercase letter (A)',
        regex: new RegExp('[A-Z]'),
    },
    {
        isPassed: false,
        hint: 'A number (1)',
        regex: new RegExp('[0-9]'),
    },
    {
        isPassed: false,
        hint: 'A special character (!@#)',
        regex: new RegExp('[-+_!@#$%^&*., ?]'), //[^a-zA-Z0-9]
    },
    {
        isPassed: false,
        hint: '8 characters minimum',
        regex: DefaultPasswordRegex,
    },
];

export const DefaultNewPasswordHints: PasswordHints[] = [
    {
        isPassed: false,
        hint: 'A Lowercase letter (a)',
        regex: new RegExp('[a-z]'),
    },
    {
        isPassed: false,
        hint: 'An Uppercase letter (A)',
        regex: new RegExp('[A-Z]'),
    },
    {
        isPassed: false,
        hint: 'A number (1)',
        regex: new RegExp('[0-9]'),
    },
    {
        isPassed: false,
        hint: 'A special character (!@#)',
        regex: new RegExp('[-+_!@#$%^&*., ?]'), //[^a-zA-Z0-9]
    },
    {
        isPassed: false,
        hint: '8 characters minimum',
        regex: DefaultPasswordRegex,
    },
];

export interface PasswordHints {
    isPassed: boolean;
    hint: string;
    regex: RegExp;
}
